import {
  AUTH_PROPERTY_COLUMN_TYPE,
  FormPageAuthInputData,
  FormPageAuthInputItem,
  FormPageAuthProperties,
  FormPageAuthProperty,
} from 'shared';
import {
  DATE_FREE,
  MAIL_ADDRESS_FREE,
  MONTH_DAY_FREE,
  NUMBER_FREE,
  PASSWORD_HASH_FREE,
  SYNERGY_ID_FREE,
  TEXT_FREE,
} from './initialValue';

const createInputItem = (
  property: FormPageAuthProperty
): FormPageAuthInputItem => {
  switch (property.detail.columnType) {
    case AUTH_PROPERTY_COLUMN_TYPE.synergyId:
      return SYNERGY_ID_FREE;
    case AUTH_PROPERTY_COLUMN_TYPE.text:
      return TEXT_FREE;
    case AUTH_PROPERTY_COLUMN_TYPE.mailAddress:
      return MAIL_ADDRESS_FREE;
    case AUTH_PROPERTY_COLUMN_TYPE.number:
      return NUMBER_FREE;
    case AUTH_PROPERTY_COLUMN_TYPE.passwordHash:
      return PASSWORD_HASH_FREE;
    case AUTH_PROPERTY_COLUMN_TYPE.date:
      return DATE_FREE;
    case AUTH_PROPERTY_COLUMN_TYPE.monthDay:
      return MONTH_DAY_FREE;

    default: {
      const v: never = property.detail;
      throw new Error(`Unknown column type: ${v}`);
    }
  }
};

type ConvertInitialValuesPayload = {
  properties: FormPageAuthProperties;
};
export const convertInitialValues = ({
  properties,
}: ConvertInitialValuesPayload): FormPageAuthInputData => {
  return Object.entries(properties).reduce<FormPageAuthInputData>(
    (acc, [propertyId, property]) => {
      return {
        ...acc,
        [propertyId]: createInputItem(property),
      };
    },
    {}
  );
};
